import { Helmet } from 'react-helmet';
import Goicuoc5gDetail
  from 'src/components/goicuoc5g-detail/Goicuoc5gDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import Goicuoc5gListToolbar from '../components/goicuoc5g-detail/Goicuoc5gToolbar';

const Goicuoc5g = () => (
  <>
    <Helmet>
      <title>Quản lý gói cước 5G</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Goicuoc5gListToolbar />
        <Box sx={{ pt: 3 }}>
          <Goicuoc5gDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Goicuoc5g;
